import GoalItemTable from './GoalItemTable';

export default GoalItemTable;
